import { render } from "./BannerAd.vue?vue&type=template&id=34b8934a&scoped=true"
import script from "./BannerAd.vue?vue&type=script&lang=js"
export * from "./BannerAd.vue?vue&type=script&lang=js"

import "./BannerAd.vue?vue&type=style&index=0&id=34b8934a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-34b8934a"]])

export default __exports__